
import moment from 'moment';
const yearPlans = ['axatp009890163', 'axatp002833004', 'axatp002833005', 'axatp002833006'];

export default {
  data() {
    return {
      fileList: {},
      productInfo: {},
      planOptionsCopy: [],
      selectedPlanCode: '',
      defaultProductCode: 'axatp002',
      cPath: ''
    }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale == 'zh-cn' ? 1 : 2
    },
    planOptions() {
      return this.$i18n.locale && this.planOptionsCopy.map((item, index) => {
        return {
          ...item,
          name: this.getNameFromIndex(index)
        }
      })
    }
  },
  created() {
    let { p, productCode } = this.$route.query;
    const defaultP = 'axatp002'; // 默认产品安盛
    p = p || defaultP;
    if (p.indexOf('BOCI') === 0) {
      this.skipModal = true;
    }
    this.cPath = p == defaultP ? '' : p + '/';

    this._productType = p;
    this.productCode = productCode;
    this.fetchProductData(p);
  },
  methods: {
    fetchProductData(p) {
      try {
        // 定义产品相关信息
        let module = require(`../data/${p}.js`);
        Object.keys(module.default).forEach(key => {
          const value = module.default[key];
          if (value.toString().indexOf('$t') > -1) {
            const transfValue = value.replace(/\$t\(\"(.*)\"\)/gi, ($0, $1) => {
              return this.$t($1);
            });
            this.productInfo[key] = transfValue
          } else {
            this.productInfo[key] = module.default[key]
          }
        });
        this.productInfo = { ...this.productInfo }
        
        // 定义保费计算相关信息
        module = require(`../data/dictData${p}.js`)
        const { columns, columnsEn, planDays, premiumRules, premiumRulesEn, notileRules, notileColumns, notileRulesEn,
          premiumColumns, premiumColumnsEn,
          bzqy, bzqyEn, calcPremium, plans, plansEn, fileList
        } = module;
        this.columns = this.currentLang == 1 ? columns : columnsEn;
        this.premiumRules = this.currentLang == 1 ? premiumRules : premiumRulesEn;
        this.notileRules = this.currentLang == 1 ? notileRules : notileRulesEn;
        this.premiumColumns = this.currentLang == 1 ? premiumColumns : premiumColumnsEn;
        this.notileColumns = notileColumns;
        this.tableData = this.currentLang == 1 ? bzqy : bzqyEn;
        this.planDays = planDays;
        this._calcPremium = calcPremium
        this.calcPremium && this.calcPremium(1, 1);
        this.fileList = fileList;

        this.plans = plans;
        this.plansEn = plansEn;
      } catch (e) {
        console.log(e)
      }
      this.getPolicyPlan(this.productCode);
    },
    clearRangeDateSelect(delay = 0) {
      const reset = () => {
        this.form.setFieldsValue({
          rangeDate: []
        });
        this.planOffsetDay = '';
        this.offsetDay = '';
      }
      if (delay) {
        let st = setTimeout(() => {
          clearTimeout(st);
          reset();
        }, delay);
        return
      }
      reset();
    },
    handlePlanSelect(val) {
      if (this.productCode == 'BOCI19') {
        this.plancode = val
        if ('BOCI195、BOCI196、BOCI197'.indexOf(val) > -1) {
          this.fullYearPlan = true
        }
        this.handleCountPremium()
      } else {
        this.fullYearPlan = yearPlans.indexOf(val) > -1 ? 1 : 0;
        const index = this.planOptions.findIndex(item => item.code == val) + 1;
        // 计划转化成数字映射来计算保费
        this._planIndex = index
        this._planValue = index
        // 添加保单页面用到
        const offsetDay = this.offsetDay
        if ((offsetDay && offsetDay < 365 && this.fullYearPlan) || (offsetDay && offsetDay > 364 && !this.fullYearPlan)) {
          this.clearRangeDateSelect()
        }
        let days = this.fullYearPlan ? 'year' : this.offsetDay || 1
        this.sumPremium = 0
        if (days) {
          this.calcPremium(days)
        }
      }
    },
    getNameFromIndex(index) {
      return this.currentLang == 1 ? this.plans[index] : this.plansEn[index];
    },
    getPolicyPlan(productCode = '') {
      this.$api.getPolicyPlan({
        productCode: productCode || 'axatp002'
      }).then(res => res.data).then(data => {
        this.planOptionsCopy = data.content.map((item, index) => {
          return {
            ...item,
            name: this.getNameFromIndex(index)
          }
        })
        this.selectedPlanCode = data.content[0].code
      }).catch(() => {
      })
    },
    disabledDate(current) {
      // Can not select days before today and today
      if (this._startDate && this._minSelectDays) {
        const offsetDay = this._minSelectDays - 1
        const endDate = moment(this._startDate).add(offsetDay, 'days')
        const startDate = moment(this._startDate).add(-offsetDay, 'days')
        return (current && (current < moment().endOf("day") || (this._startDate < current && current < endDate) || (startDate < current && current < this._startDate)))
      }
      return (
        (current && current < moment().endOf("day"))
      );
    },
    // 安盛产品，手动填充文件信息
    setASAgreementData() {
      const agreementdata = {
        customerTemplate: this.fileList[4],
        underCompanyName: this.productInfo.underCompanyName,
        materialDtoList: [
          {
            materialContent: this.fileList[1],
            materialForm: 0,
            materialName: "保险条款",
            materialType: 2,
            whetherMandatoryRead: "1"
          },
          {
            materialContent: '',
            materialForm: 2,
            materialName: "投保须知及投被保险人声明",
            materialType: 5,
            whetherMandatoryRead: "1"
          },
          {
            materialContent: this.fileList[2],
            materialForm: 0,
            materialName: "免责声明",
            materialType: 10,
            whetherMandatoryRead: "1"
          },
        ]
      }
      this.$store.commit('setagreementdata', agreementdata); //获取客户告知书承包等投保文件
      this.$store.commit('setCompanyInfo', {
        corporationName: this.productInfo.underCompanyName,
        ownAgentName: "宇泰保险经纪（北京）有限公司"
      })
    }
  }
}